module.exports = __webpack_public_path__ + "img/poster-en40x20.ce764a6e.jpg";